import { render, staticRenderFns } from "./menu-collapse.vue?vue&type=template&id=60cd53a4&"
import script from "./menu-collapse.vue?vue&type=script&lang=js&"
export * from "./menu-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports